window.True = true;
window.False = false;
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

window.cron = require('cron-parser');


Vue.config.productionTip = false;

import vuesydbase from "vue-sydbase";
Vue.use(vuesydbase);
import linq from "linq";
window.linq = linq;

window.sydhostname = "api.yixinshuke.com";
if (process.env.NODE_ENV == 'development') window.sydhostname = '127.0.0.1:9000';
// if (process.env.NODE_ENV == "development") window.sydhostname = "192.168.31.62:9000";
import axios from "axios";
axios.defaults.withCredentials = true;
axios.defaults.baseURL = (!window.sydhostname.includes(":9000") ? "https://" : "http://") + window.sydhostname;
//axios.defaults.baseURL = (!window.sydhostname.includes("127.0.0.0") ? "https://" : "http://") + window.sydhostname;
Vue.prototype.$http = axios;
// Vue.prototype.线路list = ["https://api.yixinshuke.com", "https://127.0.0.1:9000"]; //, 'https://api3.yixinshuke.com'
Vue.prototype.线路list = ["https://api.yixinshuke.com", "https://api2.yixinshuke.com"]; //, 'https://api3.yixinshuke.com'

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

import UmyUi from "umy-ui";
import "umy-ui/lib/theme-chalk/index.css";
Vue.use(UmyUi);

import elPhone from "@/components/elPhone.vue";
Vue.component("elPhone", elPhone);

import RouterTab from "vue-router-tab";
import "vue-router-tab/dist/lib/vue-router-tab.css";
Vue.use(RouterTab);

//图表组件
import VCharts from "v-charts";
Vue.use(VCharts);

import elModal from "@/components/elModal.vue";
Vue.component("elModal", elModal);
import vuedraggable from 'vuedraggable'
Vue.component('draggable', vuedraggable);

import elUploadOss from "@/components/elUploadOss.vue";
Vue.component("elUploadOss", elUploadOss);
import elCavas from "@/components/elCavas.vue";
Vue.component("elCavas", elCavas);

//本地数据库
import db from "./util/indexDB.js";
window.db = db;

window.vm = new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
window.store = store;
window.state = store.state;

window.location.query = function (name, value = null) {
    var str = location.search;
    str = str.replace(new RegExp("&amp;", "g"), "&");
    var result = str.match(new RegExp("[?&]" + name + "=([^&]+)", "i"));
    if (result == null || result.length < 1) {
        if (value)
            window.location.search +=
                (window.location.search ? "&" : "?") + name + "=" + value;
        return "";
    }
    if (value)
        window.location.search = window.location.search.replace(
            new RegExp(name + "=([^&]+)"),
            name + "=" + value
        );
    if (value == "")
        window.location.search = window.location.search.replace(
            new RegExp("[?&]" + name + "=([^&]+)"),
            ""
        );
    return result[1];
};
Vue.prototype.openDownloadDialog = function (url, saveName) {
    if (typeof url == "object" && url instanceof Blob) {
        url = URL.createObjectURL(url); // 创建blob地址
    }
    var aLink = document.createElement("a");
    aLink.href = url;
    aLink.download = saveName || ""; // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
    var event;
    if (window.MouseEvent) event = new MouseEvent("click");
    else {
        event = document.createEvent("MouseEvents");
        event.initMouseEvent("click", true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
    }
    aLink.dispatchEvent(event);
};

//excell导出导入
import XLSX from "xlsx";
Vue.prototype.sheet2blob = function (sheet, sheetName) {
    sheetName = sheetName || "sheet1";
    var workbook = {
        SheetNames: [sheetName],
        Sheets: {},
    };
    workbook.Sheets[sheetName] = sheet;
    // 生成excel的配置项
    var wopts = {
        bookType: "xlsx", // 要生成的文件类型
        bookSST: false, // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
        type: "binary",
    };

    var wbout = XLSX.write(workbook, wopts);
    var blob = new Blob([s2ab(wbout)], { type: "application/octet-stream" });
    // 字符串转ArrayBuffer
    function s2ab(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
    }
    return blob;
};
Vue.prototype.jsonToExcell = function (data = [], filename = "导出excell文件") {
    if (data.length < 1) throw "导出数据为空!";
    let sheet = "";
    if (Array.isArray(data[0])) {
        let count = 0;
        data.forEach((row, index) => {
            if (index == 0) {
                sheet = XLSX.utils.json_to_sheet(row);
                count = row.length + 1; //标题占一行
            } else {
                if (row.length > 0)
                    sheet = XLSX.utils.sheet_add_json(sheet, row, { origin: count });
                count += row.length + 1; //标题占一行
            }
        });
    } else {
        sheet = XLSX.utils.json_to_sheet(data);
    }
    this.openDownloadDialog(this.sheet2blob(sheet), filename + ".xlsx");
};
Vue.prototype.excelToJSON = async function (file, 开始行号 = 0) {
    if (!file.content) throw "file.content为空!";
    var data = file.content;
    data = data.split(",")[1];
    const workbook = XLSX.read(data, { type: "base64" });
    let sheet = workbook.Sheets[workbook.SheetNames[0]];
    if (!sheet) throw "excell中未找到sheet页";
    const sheetArray = XLSX.utils.sheet_to_json(sheet, { range: 开始行号 });
    return sheetArray;
};
Vue.prototype.excelToCSV = async function (file) {
    if (!file.content) throw "file.content为空!";
    await window.delay(100);
    var data = file.content;
    data = data.split(",")[1];
    const workbook = XLSX.read(data, { type: "base64" });
    let sheet = workbook.Sheets[workbook.SheetNames[0]];
    if (!sheet) throw "excell中未找到sheet页";
    return await XLSX.utils.sheet_to_csv(sheet);
};

Vue.prototype.bhtoname = function (list, 返回name, 搜索name, 搜索value) {
    try {
        if (!list) return "";
        if (typeof 搜索value == undefined) return "";
        let tmp = list.FirstOrDefault((a) => a[搜索name] == 搜索value);
        if (!tmp) return "";
        if (tmp) return tmp[返回name];
    } catch (error) {
        console.log(error);
    }
    return "";
};

//
Vue.prototype.快捷日期区间选择 = function (类型 = "天最近月年") {
    let shortcuts = [];
    if (类型.includes("天"))
        shortcuts.push(
            ...[
                {
                    text: "今天",
                    onClick(picker) {
                        const start = new Date();
                        const end = new Date();
                        picker.$emit("pick", [start, end]);
                    },
                },
                {
                    text: "昨天",
                    onClick(picker) {
                        const start = new Date().addDays(-1);
                        const end = new Date().addDays(-1);
                        picker.$emit("pick", [start, end]);
                    },
                },
                {
                    text: "前天",
                    onClick(picker) {
                        const start = new Date().addDays(-2);
                        const end = new Date().addDays(-2);
                        picker.$emit("pick", [start, end]);
                    },
                },
            ]
        );
    if (类型.includes("最近"))
        shortcuts.push(
            ...[
                {
                    text: "最近一周",
                    onClick(picker) {
                        const start = new Date().addDays(-7);
                        const end = new Date();
                        picker.$emit("pick", [start, end]);
                    },
                },
                {
                    text: "最近一个月",
                    onClick(picker) {
                        const start = new Date().addDays(-30);
                        const end = new Date();
                        picker.$emit("pick", [start, end]);
                    },
                },
                {
                    text: "最近三个月",
                    onClick(picker) {
                        const start = new Date().addDays(-90);
                        const end = new Date();
                        picker.$emit("pick", [start, end]);
                    },
                },
            ]
        );
    if (类型.includes("月"))
        shortcuts.push(
            ...[
                {
                    text: "本月",
                    onClick(picker) {
                        const start = new Date().monthStart();
                        const end = new Date().monthEnd();
                        picker.$emit("pick", [start, end]);
                    },
                },
                {
                    text: "上月",
                    onClick(picker) {
                        const start = new Date().addMonths(-1).monthStart();
                        const end = new Date().addMonths(-1).monthEnd();
                        picker.$emit("pick", [start, end]);
                    },
                },
            ]
        );
    if (类型.includes("年"))
        shortcuts.push(
            ...[
                {
                    text: "本年",
                    onClick(picker) {
                        const start = new Date().yearfirstdate().monthStart();
                        const end = new Date().yearlastdate().monthEnd();
                        picker.$emit("pick", [start, end]);
                    },
                },
                {
                    text: "去年",
                    onClick(picker) {
                        const start = new Date().yearfirstdate().addYears(-1).monthStart();
                        const end = new Date().yearlastdate().addYears(-1).monthEnd();
                        picker.$emit("pick", [start, end]);
                    },
                },
            ]
        );
    return { shortcuts };
};
Vue.prototype.快捷日期选择 = function (类型 = "天最近月年") {
    let shortcuts = [];
    if (类型.includes("天"))
        shortcuts.push(
            ...[
                {
                    text: "今天",
                    onClick(picker) {
                        picker.$emit("pick", new Date());
                    },
                },
                {
                    text: "昨天",
                    onClick(picker) {
                        picker.$emit("pick", new Date().addDays(-1));
                    },
                },
                {
                    text: "前天",
                    onClick(picker) {
                        picker.$emit("pick", new Date().addDays(-2));
                    },
                },
            ]
        );
    if (类型.includes("月"))
        shortcuts.push(
            ...[
                {
                    text: "一月前",
                    onClick(picker) {
                        picker.$emit("pick", new Date().addMonths(-1));
                    },
                },
                {
                    text: "三月前",
                    onClick(picker) {
                        picker.$emit("pick", new Date().addMonths(-1));
                    },
                },
                {
                    text: "六月前",
                    onClick(picker) {
                        picker.$emit("pick", new Date().addMonths(-1));
                    },
                },
            ]
        );
    if (类型.includes("年"))
        shortcuts.push(
            ...[
                {
                    text: "一年前",
                    onClick(picker) {
                        picker.$emit("pick", new Date().addYears(-1));
                    },
                },
                {
                    text: "二年前",
                    onClick(picker) {
                        picker.$emit("pick", new Date().addYears(-2));
                    },
                },
            ]
        );
    return { shortcuts };
};

//table控件列格式化
Vue.prototype.tabelColNumber = function (row, column, value, index, xs = 2) {
    try {
        return value.toFixed(xs);
    } catch (error) {
        //
    }
    return value;
};
Vue.prototype.tabelColNumber4 = function (row, column, value, index, xs = 4) {
    try {
        return value.toFixed(xs);
    } catch (error) {
        //
    }
    return value;
};
Vue.prototype.tabelColDate = function (row, column, value) {
    try {
        if (!value) return "";
        let tmp = new Date(value);
        if (tmp.format() == new Date(1970, 0, 1).format()) return "";
        return tmp.format("yyyy/MM/dd");
    } catch (error) {
        //
    }
    return value;
};
Vue.prototype.tabelColDateTime = function (row, column, value) {
    try {
        let tmp = new Date(value);
        if (tmp.format() == new Date(1970, 0, 1).format()) return "";
        return tmp.format();
    } catch (error) {
        //
    }
    return value;
};
Vue.prototype.tabelColBool = function (row, column, value = "") {
    try {
        return value ||
            value == "1" ||
            value == "是" ||
            value == "真" ||
            value.toString().toLowerCase() == "true"
            ? "是"
            : "否";
    } catch (error) {
        console.log(error);
    }
    return value;
};
//table合计
Vue.prototype.onSumMethod = function (para, collist = [], 合计数据 = {}) {
    let { columns, data } = para;
    const sums = [];
    let v = 1000;

    columns.forEach((column, index) => {
        if (index === 0) {
            sums[index] = "合计";
            return;
        }
        let J_col = collist.FirstOrDefault((a) => a.label == column.label);
        if (collist.length > 0 && !J_col) sums[index] = "";
        else {
            if (J_col && J_col.field) {
                if (J_col.field.includes("-") || J_col.field.includes("+")) {
                    let str = J_col.field;
                    let fieldlist = str.split(/×|-|÷|[+]/);
                    fieldlist.forEach((e) => {
                        str = str.replace(e, 合计数据[e]);
                    });
                    sums[index] = eval(str) || 0;
                } else {
                    sums[index] = 合计数据[J_col.field] || "";
                }
            } else {
                const values = data.map((item) => Number(item[column.property]));
                if (!values.every((value) => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return (prev * v + curr * v) / v;
                        } else {
                            return prev;
                        }
                    }, 0);
                } else {
                    sums[index] = "";
                }
            }

            if (sums[index]) {
                if (J_col && J_col.round)
                    sums[index] = Math.round(sums[index], J_col.round);
                if (J_col && J_col.toFixed)
                    sums[index] = sums[index].toFixed(J_col.toFixed);
                if (J_col && J_col.unit) sums[index] += J_col.unit;
            }
        }
    });
    return [sums];
};
Vue.prototype.onelSumMethod = function (para, collist = [], 合计数据 = {}) {
    let { columns, data } = para;
    const sums = [];
    let v = 1000;

    columns.forEach((column, index) => {
        if (index === 0) {
            sums[index] = "合计";
            return;
        }
        let J_col = collist.FirstOrDefault((a) => a.label == column.label);
        if (collist.length > 0 && !J_col) sums[index] = "";
        else {
            if (J_col && J_col.field) {
                if (J_col.field.includes("-") || J_col.field.includes("+")) {
                    let str = J_col.field;
                    let fieldlist = str.split(/×|-|÷|[+]/);
                    fieldlist.forEach((e) => {
                        str = str.replace(e, 合计数据[e]);
                    });
                    sums[index] = eval(str) || 0;
                } else {
                    sums[index] = 合计数据[J_col.field] || "";
                }
            } else {
                const values = data.map((item) => Number(item[column.property]));
                if (!values.every((value) => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return (prev * v + curr * v) / v;
                        } else {
                            return prev;
                        }
                    }, 0);
                } else {
                    sums[index] = "";
                }
            }
            if (sums[index]) {
                if (J_col && J_col.round)
                    sums[index] = Math.round(sums[index], J_col.round);
                if (J_col && J_col.toFixed)
                    sums[index] = sums[index].toFixed(J_col.toFixed);
                if (J_col && J_col.unit) sums[index] += J_col.unit;
            }
        }
    });
    return sums;
};
//回车跳转
let inputOnKeyUp = function (ev) {
    if (ev.srcElement.myonkeyup) ev.srcElement.myonkeyup(ev);
};
Vue.prototype.addEnterToTab = async function (name) {
    await window.delay(200);
    let inputs = this.$refs[name].$el.querySelectorAll("input");
    //绑定回写事件
    for (var i = 0; i < inputs.length; i++) {
        inputs[i].setAttribute("keyFocusIndex", i);
        inputs[i].removeEventListener("keyup", inputOnKeyUp);
        inputs[i].addEventListener("keyup", inputOnKeyUp);
        inputs[i].myonkeyup = (ev) => {
            if (ev.keyCode === 13 || ev.keyCode === 39) {
                let targetTo = ev.srcElement.getAttribute("keyFocusTo");
                if (targetTo) {
                    this.$refs[targetTo].$el.focus();
                    setTimeout(() => {
                        this.$refs[targetTo].$el.select();
                    }, 200);
                } else {
                    let attrIndex = ev.srcElement.getAttribute("keyFocusIndex");
                    let ctlI = parseInt(attrIndex);
                    try {
                        window.aaa = ev.srcElement;
                        //select控件
                        ev.srcElement.parentElement.parentElement.__vue__.blur();
                    } catch (error) {
                        //
                    }
                    if (ctlI < inputs.length - 1) {
                        inputs[ctlI + 1].focus();
                        setTimeout(() => {
                            inputs[ctlI + 1].select();
                        }, 200);
                    }
                }
            }
            if (ev.keyCode === 37) {
                let attrIndex = ev.srcElement.getAttribute("keyFocusIndex");
                let ctlI = parseInt(attrIndex);
                if (ctlI > 0) {
                    inputs[ctlI - 1].focus();
                    setTimeout(() => {
                        inputs[ctlI - 1].select();
                    }, 200);
                }
            }
        };
    }
};

Array.prototype.OrderBy = function (e) {
    return linq.from(this).orderBy(e).toArray();
};
Array.prototype.OrderByDescending = function (e) {
    return linq.from(this).orderByDescending(e).toArray();
};
Array.prototype.Max = function (e) {
    if (this.length < 1) return null;
    return linq.from(this).max(e);
};
Array.prototype.MaxBy = function (e) {
    if (this.length < 1) return null;
    return linq.from(this).maxBy(e);
};
Array.prototype.MaxBhAdd = function (e) {
    if (this.length < 1) return 1;
    let tmp = linq.from(this).maxBy((a) => {
        let tmpbh = (a[e] || "").toString();
        tmpbh = (/(\d+)$/g.exec(tmpbh) || [])[0] || 0; //获取数字部分
        return parseInt(tmpbh);
    });
    let maxbh = (tmp[e] || "0").toString().replace(/(\d+)$/g, function (a) {
        return parseInt(a) + 1;
    });
    console.log({ maxbh });
    if (maxbh == tmp[e]) maxbh += 1;
    return maxbh;
};
Array.prototype.GroupBy = function (a, b = null, c, d = null) {
    c =
        c ||
        ((key, mx) => {
            return { key, count: mx.toArray().length, mx: mx.toArray() };
        });
    return linq.from(this).groupBy(a, b, c, d).toArray();
};

String.prototype.tryParseInt = function () {
    let tmp = parseInt(this);
    if (isNaN(tmp)) return this;
    return tmp;
};


window.waitTimerList = [];
Vue.prototype.$wait = function (flag, time = 1000, errmsg = null, vuePage = null) {
    let start = new Date(),
        _this = this;
    return new Promise((resolve, rejected) => {
        let check = async function (flag, time, errmsg) {
            let checkresult = false;
            try {
                if (typeof flag == "function") await flag(_this);
                else checkresult = eval("_this." + flag);
                //flag不能直接传值,因为值改变后,函数里不会改变
            } catch (error) {
                console.log(error);
            }
            if (checkresult) {
                resolve("成功");
            } else {
                if (new Date() - start < time) {
                    if (!window.waitTimerList) window.waitTimerList = [];
                    let tmp = setTimeout(() => {
                        let index = window.waitTimerList.indexOf(tmp);
                        if (index >= 0) window.waitTimerList.splice(index, 1);

                        check(flag, time, errmsg);
                    }, 100);
                    if (vuePage) vuePage.waitTimer = tmp;
                    window.waitTimerList.push(tmp);
                } else {
                    rejected(errmsg || "等待结果超时(" + time + ")");
                }
            }
        };
        check(flag, time, errmsg);
    });
};